import { ACTIVE_SUBSCRIPTION_STATUSES } from '../constants/subscriptions/activeStatuses';
import { Subscription, SubscriptionResponse } from '../types/Subscription';

export const isSubscriptionActive = (
    subscription: Subscription | SubscriptionResponse | null,
) => {
    if (!subscription) {
        return false;
    }

    const status = subscription.status;
    let validUntil: string | null = null;

    if ('valid_until' in subscription) {
        validUntil = subscription.valid_until;
    } else {
        validUntil = subscription.validUntil;
    }

    const now = Date.now();
    const hasActiveStatus = ACTIVE_SUBSCRIPTION_STATUSES.includes(status);

    const isOverdue =
        !validUntil ||
        Boolean(validUntil && now > new Date(validUntil).getTime());

    return hasActiveStatus && !isOverdue;
};
